import { actions } from "store/actions";

const initialState = {
  totalEarning: {
    totalEarning: 0,
    pendingEarning: 0,
    paidEarning: 0,
    dueToday: 0,
  },
  agencyEarnings: { result: [], count: 0 },
  vendorEarnings: { result: [], count: 0 },
  posForInvoice: { result: [], count: 0 },
};

export const earningsReducers = {
  totalEarning(state = initialState.totalEarning, action) {
    switch (action.type) {
      case actions.VM_SET_TOTAL_EARNING:
        return action.payload;
      default:
        return state;
    }
  },

  agencyEarnings(state = initialState.agencyEarnings, action) {
    switch (action.type) {
      case actions.VM_SET_AGENCY_EARNINGS:
        return action.payload;
      case actions.VM_UPDATE_EARNING_STATUS: {
        if (!action.isAgency) return state;
        const { assigneeId, status } = action;
        return {
          ...state,
          result: (state.result || []).map((row) =>
            row.assigneeId === assigneeId ? { ...row, status } : row
          ),
        };
      }
      default:
        return state;
    }
  },

  vendorEarnings(state = initialState.vendorEarnings, action) {
    switch (action.type) {
      case actions.VM_SET_VENDOR_EARNINGS:
        return action.payload;
      case actions.VM_UPDATE_EARNING_STATUS: {
        if (action.isAgency) return state;
        const { assigneeId, status } = action;
        return {
          ...state,
          result: (state.result || []).map((row) =>
            row.assigneeId === assigneeId ? { ...row, status } : row
          ),
        };
      }
      default:
        return state;
    }
  },

  posForInvoice(state = initialState.posForInvoice, action) {
    switch (action.type) {
      case actions.VM_SET_POS_FOR_INVOICE:
        return action.payload;

      case actions.VM_SET_LOAD_MORE_POS_FOR_INVOICE:
        return {
          ...state,
          result: [...state.result, ...action.payload.result],
        };

      default:
        return state;
    }
  },
};
